import { gql } from '@apollo/client';

const UPDATE_FOLDER_COLOR = gql`
  mutation UpdateFolderColor($folderId: Int!, $color: String) {
    updateFolderColor(folderId: $folderId, color: $color)
  }
`;

export default UPDATE_FOLDER_COLOR;
